import React, {useState} from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Input,
  Box,
} from "@material-ui/core";
import {getCookie} from "components/auth/Helpers";

const UploadExcel = ({visible, onClose}) => {
  const token = getCookie("token");
  const [file, setFile] = useState(null);
  const [msg, setMsg] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMsg("");
  };

  const handleUpload = async () => {
    if (!file) {
      setMsg("⚠️ Please select a file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/import/stores`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      setMsg("✅ Upload successful");
      onClose(true);
    } catch (err) {
      console.error(err);
      setMsg("❌ Upload failed");
    }
  };

  return (
    <Dialog open={visible} onClose={onClose} maxWidth="md" fullWidth disableBackdropClick>
      <DialogTitle>Import Excel</DialogTitle>

      <Box mb={2}>
        <Button variant="outlined" color="primary" href="/storesImportSample.xlsx" download>
          Download Excel Sample
        </Button>
      </Box>

      <DialogContent>
        <Input type="file" inputProps={{accept: ".xlsx, .xls"}} onChange={handleFileChange} />
        {msg && (
          <Typography variant="body2" style={{marginTop: 10}}>
            {msg}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleUpload} color="primary" variant="contained">
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadExcel;
